module.exports = __webpack_public_path__ + "img/info-1.2f4048dc.png";